<onyx-icon-box class="bar-icon" color="white" [size]="20" [hasShadow]="true">
  <onyx-icon name="documents-filled" [size]="14"></onyx-icon>
</onyx-icon-box>

@let controls = form().controls;
<onyx-textarea
  class="note"
  [formControl]="controls.driverNote"
  label="labels.driverNote"
  minResizeHeight="80px"
></onyx-textarea>

@if ('referenceNumber' in controls) {
  <onyx-text-field
    class="reference-number"
    [formControl]="controls.referenceNumber"
    [size]="32"
    label="labels.pointReferenceNumber"
  ></onyx-text-field>
} @else if ('phone' in controls) {
  <onyx-phone-number-input
    class="phone"
    [formControl]="controls.phone"
    label="labels.phone"
    [size]="32"
  ></onyx-phone-number-input>
}
